import { TextField, makeStyles } from "@material-ui/core"

interface DaysHoursMinutesPickerProps {
  value: {
    days: number
    hours: number
    minutes: number
  }
  onTimeUnitChange: (unit: "days" | "hours" | "minutes", value: number) => void
}

/**
 * Displays three numeric inputs for days, hours, and minutes, and reports
 * changes back to the parent via `onTimeUnitChange` for each time unit.
 */
export default function DaysHoursMinutesPicker({
  value,
  onTimeUnitChange,
}: DaysHoursMinutesPickerProps) {
  const classes = useStyles()

  return (
    <div className={classes.inputContainer}>
      <UnitInput
        label="Days"
        value={value.days}
        onChange={(v) => onTimeUnitChange("days", v)}
      />
      <UnitInput
        label="Hours"
        value={value.hours}
        onChange={(v) => onTimeUnitChange("hours", v)}
      />
      <UnitInput
        label="Minutes"
        value={value.minutes}
        onChange={(v) => onTimeUnitChange("minutes", v)}
      />
    </div>
  )
}

const UnitInput = ({
  label,
  value,
  onChange,
}: {
  label: string
  value: number
  onChange: (value: number) => void
}) => {
  const inputId = `unit-input-${label.toLowerCase()}`

  return (
    <>
      <TextField
        id={inputId}
        variant="outlined"
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value, 10) || 0)}
      />
      <label htmlFor={inputId}>{label}</label>
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  inputContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(1),
  },
}))
